module.exports = "https://cdn.hellotech.com/client-assets/logo_usatoday_69daaba2b78151a77b9cb43c9462f1ba.png";